import icon from 'assets/img/icons/special-offers.svg';
import useProfile from 'hooks/useProfile';


const AddFundsPopupStart = ({setStep}) => {
  const {balance} = useProfile();

  const nextStep = () => {
    setStep('success');
  }

  return (
    <>
    <header className="modal-window__header">
      <img src={icon} className="modal-window__icon" alt="" />
    </header>
    <section className="purchase-form__balance">
      <span className="purchase-form__balance-title">Your account balance is:</span>
      <b className="purchase-form__balance-current">${balance ? balance : 0} USD</b>
    </section>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={nextStep}>Add Funds</button>
      </footer>
    </>
  )
}

export default AddFundsPopupStart
